(function () {
  var cfg = window.__langToggle || {};
  if (cfg.enabled === false) return;
  var enLabel = cfg.en || 'EN';
  var nlLabel = cfg.nl || 'NL';
  var current = cfg.current || 'en';

  function paths() {
    var p = window.location.pathname;
    var search = window.location.search || '';
    var stripped = p.replace(/^\/nl(\/|$)/, '/');
    if (stripped === '') stripped = '/';
    var nlPath = stripped === '/' ? '/nl' : '/nl' + stripped;
    return { en: stripped + search, nl: nlPath + search };
  }

  function build() {
    var p = paths();
    var wrap = document.createElement('div');
    wrap.className = 'lang-toggle';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Language');
    var a1 = document.createElement('a');
    a1.href = p.en; a1.textContent = enLabel; a1.setAttribute('hreflang', 'en');
    var a2 = document.createElement('a');
    a2.href = p.nl; a2.textContent = nlLabel; a2.setAttribute('hreflang', 'nl');
    if (current === 'nl') { a2.className = 'is-active'; } else { a1.className = 'is-active'; }
    wrap.appendChild(a1); wrap.appendChild(a2);
    return wrap;
  }

  function place() {
    if (document.querySelector('.lang-toggle')) return true;
    var targets = [
      document.querySelector('.header__row .header-buy-the-book'),
      document.querySelector('.cosi-header__cta'),
      document.querySelector('.pf-header__cta'),
      document.querySelector('header a[href*="pricing"]'),
      document.querySelector('.header__row')
    ];
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t && t.parentNode) {
        var el = build();
        if (i < 4) { t.parentNode.insertBefore(el, t.nextSibling); } else { t.appendChild(el); }
        return true;
      }
    }
    return false;
  }

  function start() {
    if (place()) return;
    var n = 0;
    var iv = setInterval(function () { if (place() || ++n > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { setTimeout(place, 50); });
})();